import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSizeL = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 35.195 26.396",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "L_Banner",
		transform: "translate(6680 21271)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_177",
			"data-name": "Group 177",
			transform: "translate(-6680 -21271)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_204",
				"data-name": "Path 204",
				d: "M32.262,4.466a1.385,1.385,0,0,1,1.466,1.466v20.53a1.385,1.385,0,0,1-1.466,1.466H2.933a1.385,1.385,0,0,1-1.466-1.466V5.933A1.385,1.385,0,0,1,2.933,4.466H32.262m0-1.466H2.933A2.942,2.942,0,0,0,0,5.933v20.53A2.942,2.942,0,0,0,2.933,29.4H32.262a2.942,2.942,0,0,0,2.933-2.933V5.933A2.942,2.942,0,0,0,32.262,3Z",
				transform: "translate(0 -3)"
			})
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_2709",
			"data-name": "Path 2709",
			d: "M3.061,1.75H8.078v1.9H.7V-7.82H3.061Z",
			transform: "translate(-6665.325 -21255.715)"
		})]
	})
});
export default SvgSizeL;
